import type { ComponentProps, ReactNode } from 'react';
import { forwardRef } from 'react';
import styled from 'styled-components';
import type { CarouselItemState } from './types';
import { useCarouselItemState } from './utils';

export const CarouselItemContainer = styled.div``;

export type CarouselItemProps = Omit<
  ComponentProps<typeof CarouselItemContainer>,
  'children'
> & {
  children?: ReactNode | ((itemState: CarouselItemState) => ReactNode);
};

export const CarouselItem = forwardRef<HTMLDivElement, CarouselItemProps>(
  function CarouselItem({ children, ...forwardingProps }, forwardingRef) {
    const carouselItemState = useCarouselItemState();

    return (
      <CarouselItemContainer {...forwardingProps} ref={forwardingRef}>
        {typeof children === 'function'
          ? children(carouselItemState)
          : children}
      </CarouselItemContainer>
    );
  }
);
